export const data = {
  imgObj: {
    alt: '',
    src: 'https://media.product.which.co.uk/prod/images/original/d644cfc65ba1-tooliconnumber8.jpg',
  },
  title: 'What is the violation code or reason quoted on the ticket?',
}
